<template>
  <v-app>
    <div>
      <v-app-bar
        v-show="!hiddenToolbar"
        fixed
        app
        color="primary"
        density="compact"
        dark
        class="hidden-print-only"
      >
        <v-app-bar-nav-icon
          class="ml-2"
          v-if="!showComputer"
          @click.stop="drawer = !drawer"
        ></v-app-bar-nav-icon>
        <v-btn v-if="showComputer" icon text @click="$router.back()">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title>
          <v-btn
            @focus="selectedComputer = 'home'"
            :style="{
              backgroundColor:
                selectedComputer == 'home' ? '#000080' : 'transparent',
            }"
            text
            @click="changeRouter('/home', 'Home')"
            style="text-transform: none"
          >
            {{ clickPath }}
          </v-btn>
          <!-- <v-progress-circular
            v-if="loading"
            :indeterminate="loading"
            color="dark-blue"
          ></v-progress-circular> -->
        </v-toolbar-title>

        <div class="flex-grow-1"></div>
        <v-btn
          v-if="pgList.length > 0"
          :style="{
            backgroundColor:
              selectedComputer == 'change' ? '#000080' : 'transparent',
          }"
          @focus="selectedComputer = 'change'"
          @click="reloadPage()"
        >
          <v-icon v-if="customerOrPage == 'C'">mdi-language-c</v-icon>
          <v-icon v-else>mdi-parking</v-icon>
        </v-btn>
        <v-btn
          v-if="customerOrPage == 'C'"
          :style="{
            backgroundColor:
              selectedComputer == 'search' ? '#000080' : 'transparent',
          }"
          @focus="selectedComputer = 'search'"
          @click="changeRouter('/search', 'Search')"
        >
          <v-icon>mdi-magnify</v-icon>
        </v-btn>

        <v-btn
          :style="{
            backgroundColor:
              selectedComputer == 'noti' ? '#000080' : 'transparent',
          }"
          @focus="selectedComputer = 'noti'"
          @click="changeRouter('/noti', 'Noti')"
        >
          <v-badge v-if="notiCount > 0" :content="notiCount" color="black">
            <v-icon>mdi-bell</v-icon>
          </v-badge>
          <v-icon v-else>mdi-bell</v-icon>
        </v-btn>

        <v-toolbar-items v-if="showComputer">
          <v-menu v-if="customerOrPage != 'C' || loginUser.role == 'ADMIN'">
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                :style="{
                  backgroundColor:
                    selectedComputer == 'pag' ? '#000080' : 'transparent',
                }"
              >
                <span class="ml-2" style="text-transform: none">Page</span>
                <v-icon>mdi-menu-down-outline</v-icon>
              </v-btn>
            </template>

            <v-list density="compact">
              <v-list-item
                v-for="(item, i) in page"
                :key="i"
                :value="item"
                @click="changeRouter(item.value, item.clickPath)"
                @focus="selectedComputer = 'pag'"
              >
                <template v-slot:prepend>
                  <v-icon :icon="item.icon"></v-icon>
                </template>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-menu v-if="loginUser.role == 'ADMIN'">
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                :style="{
                  backgroundColor:
                    selectedComputer == 'set' ? '#000080' : 'transparent',
                }"
              >
                <span class="ml-2" style="text-transform: none">Settings</span>
                <v-icon>mdi-menu-down-outline</v-icon>
              </v-btn>
            </template>

            <v-list density="compact">
              <v-list-item
                v-for="(item, i) in settings"
                :key="i"
                :value="item"
                @click="changeRouter(item.value, item.clickPath)"
                @focus="selectedComputer = 'set'"
              >
                <template v-slot:prepend>
                  <v-icon :icon="item.icon"></v-icon>
                </template>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-menu>
            <template v-slot:activator="{ props }">
              <v-btn v-bind="props">
                <span class="ml-2" style="text-transform: none">{{
                  loginUser.profileName
                }}</span>
              </v-btn>
            </template>

            <v-list density="compact">
              <v-list-item
                v-for="(item, i) in profileList"
                :key="i"
                :value="item"
                @click="changeRouter(item.value, item.clickPath)"
              >
                <template v-slot:prepend>
                  <v-icon :icon="item.icon"></v-icon>
                </template>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar-items>
      </v-app-bar>
      <v-navigation-drawer v-model="drawer" fixed temporary>
        <div class="mt-2 ml-2 mb-2">
                  <v-avatar
                  variant="outlined"
                        :image="
                          srcMethodProfile(loginUser.profilePhoto)
                        "
                        size="60"
                      ></v-avatar>
                    <span class="ml-2 ">{{ loginUser.profileName }}</span></div>
        <v-divider></v-divider>

        <v-list nav density="compact">
          <v-list-group
            prepend-icon="mdi-cog-outline"
            v-if="customerOrPage != 'C' || loginUser.role == 'ADMIN'"
          >
            <template v-slot:activator="{ props }">
              <v-list-item v-bind="props" title="Pages"></v-list-item>
            </template>
            <v-list-item
              v-for="(item, i) in page"
              :key="i"
              :title="item.title"
              :value="item.title"
              link
              @click="changeRouter(item.value, item.clickPath)"
              @focus="selectIndex = item.value"
              :style="{
                backgroundColor:
                  selectIndex == item.value ? '#def3ff' : 'transparent',
              }"
            ></v-list-item>
          </v-list-group>
          <v-list-group
            prepend-icon="mdi-cog-outline"
            v-if="customerOrPage != 'C' || loginUser.role == 'ADMIN'"
          >
            <template v-slot:activator="{ props }">
              <v-list-item v-bind="props" title="Settings"></v-list-item>
            </template>
            <v-list-item
              v-for="(item, i) in settings"
              :key="i"
              :title="item.title"
              :value="item.title"
              link
              @click="changeRouter(item.value, item.clickPath)"
              @focus="selectIndex = item.value"
              :style="{
                backgroundColor:
                  selectIndex == item.value ? '#def3ff' : 'transparent',
              }"
            ></v-list-item>
          </v-list-group>

          <v-list-item
            v-for="(item, i) in menuProfileList"
            :key="i"
            :value="item"
            @click="changeRouter(item.value, item.clickPath)"
          >
            <template v-slot:prepend>
              <v-icon :icon="item.icon"></v-icon>
            </template>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>

        <template v-slot:append>
          <div class="pa-2">
            <v-btn
              class="red--text"
              block
              rounded
              color="primary"
              @click="changeRouter('/logout', 'Home')"
            >
              <v-icon>mdi-logout</v-icon>Logout
            </v-btn>
          </div>
        </template>
      </v-navigation-drawer>
      <div class="mt-12 hidden-print-only"></div>
      <v-container fluid class="mt-0 pa-0">
        <router-view :hideToolbar="hideToolbar" />
      </v-container>

      <div>
        <v-dialog v-model="logoutModel" persistent max-width="350">
          <v-card>
            <v-card-title class="title">ထွက်ရန် သေချာပြီလား?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" text @click="logoutModel = false"
                >မလုပ်ပါ</v-btn
              >
              <v-btn color="primary" depressed @click="logout">ထွက်မည်</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <div>
        <v-dialog v-model="passwordModel" persistent max-width="400">
          <v-form ref="form" v-model="valid">
            <v-card>
              <v-card-title class="headline"
                >စကား၀ှက် ပြောင်းတော့မှာလား?</v-card-title
              >
              <v-card-text class="pb-0">
                <v-text-field
                  :append-icon="showOld ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showOld ? 'text' : 'password'"
                  @click:append="showOld = !showOld"
                  :rules="passwordOldRule"
                  v-model="password.old"
                  label="Old Password"
                  name="oldPassword"
                  placeholder=" "
                  outlined
                  dense
                ></v-text-field>
                <v-text-field
                  :append-icon="showNew ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showNew ? 'text' : 'password'"
                  @click:append="showNew = !showNew"
                  :rules="passwordNewRule"
                  v-model="password.new"
                  label="New Password"
                  name="newPassword"
                  placeholder=" "
                  outlined
                  dense
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" text @click="cancelChangePassword"
                  >မပြောင်းတော့ပါ</v-btn
                >
                <v-btn
                  color="primary"
                  :disabled="!valid"
                  depressed
                  @click="changePassword"
                  >ပြောင်းမည်</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </div>
    </div>
  </v-app>
</template>

<script>
import axios from "../src/config";
import accountUserService from "./service/UserAccountService";
import pgService from "./service/PageService";
import notiService from "./service/NotiService";
export default {
  data() {
    return {
      hiddenToolbar: true,
      logoutModel: false,
      passwordModel: false,
      showOld: false,
      showNew: false,
      password: {},
      valid: true,
      passwordOldRule: [(v) => !!v || "Old Password is required"],
      passwordNewRule: [(v) => !!v || "New Password is required"],
      setting: {},
      limitDialog: false,
      loginUser: "",
      loadingCount: 0,
      loading: false,
      drawer: false,
      mini: true,
      settings: [],
      page: [],

      menuProfileList: [
        {
          title: "Profile",
          icon: "mdi-emoticon-outline",
          value: "/userform",
          clickPath: "Profile",
        },
        {
          title: "Change Password",
          icon: "mdi-lock",
          value: "/change_password",
          clickPath: "Change Password",
        },
      ],
      profileList: [
        {
          title: "Profile",
          icon: "mdi-emoticon-outline",
          value: "/userform",
          clickPath: "Profile",
        },
        {
          title: "Change Password",
          icon: "mdi-lock",
          value: "/change_password",
          clickPath: "Change Password",
        },
        {
          title: "Logout",
          icon: "mdi-logout",
          value: "/logout",
          clickPath: "LogOut",
        },
      ],
      selectIndex: "home",
      selectedComputer: "home",
      clickPath: "Home",
      uiAccept: {},
      customerOrPage: "C",
      notiCount: 0,
      pgList: [],
    };
  },
  props: {},
  computed: {
    showComputer() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return false;
        case "sm":
          return false;
        case "md":
          return true;
        case "lg":
          return true;
        case "xl":
          return true;
      }
    },
    isLogin: function () {
      let token = this.$store.state.userAccountChat.password;
      if (token == "") {
        return false;
      } else {
        axios.defaults.headers.common["Authorization"] = `chat${token}`;
        this.customerOrPage = this.$store.state.customerOrPage;
        this.uiAcceptMethod();
        return true;
      }
    },
  },
  mounted: function () {
    this.hiddenToolbar = false;
    this.loginMounted();
    axios.interceptors.request.use((config) => {
      this.loadingCount++;
      if (!this.loading) {
        this.loading = true;
      }
      return config;
    });
    axios.interceptors.response.use(
      (response) => {
        this.loadingCount--;
        if (this.loadingCount == 0 && this.loading) {
          this.loading = false;
        }
        return response;
      },
      (error) => {
        if (error.isAxiosError && error.message == "Network Error") {
          this.$swal("အင်တာနက် လိုင်းမကောင်းပါ", error.message, "error");
          this.loadingCount = 1;
          this.loading = false;
        }
        if (error.response.data != null && error.response.data.status == 401) {
          this.$swal(
            "Authentication Error",
            "ထွက်မည် ခလုတ်နှိပ်ပေးပါ",
            "error"
          );
          this.changeRouter("/logout", "Home");
          this.logout();
        }
        this.loadingCount--;
        if (this.loadingCount == 0 && this.loading) {
          this.loading = false;
        }
        return Promise.reject(error);
      }
    );
  },
  methods: {
    srcMethodProfile: function (pictureCode) {
        return `${axios.defaults.baseURL}/userphoto/${pictureCode}.png`;
    },
    pageListMethod: function () {
      pgService
        .getPage("P")
        .then((response) => {
          this.pgList.splice(0, this.pgList.length);
          this.pgList.push(...response);
        })
        .catch((error) => {
          //this.$swal("Fail!", error.response.data.message, "error");
        });
    },
    disconnect() {
      if (this.stompClient) {
        this.stompClient.disconnect();
      }
      this.connected = false;
    },
    connection() {
      this.connected ? this.disconnect() : this.connect();
    },
    connect() {
      let socket = new SockJS("/chat");
      this.stompClient = Stomp.over(socket);
      this.stompClient.connect(
        {},
        (frame) => {
          this.connected = true;
          this.stompClient.subscribe(
            "/mbt/noticount/" + this.loginUser.userId,
            (response) => {
              this.notiCount = JSON.parse(response.body);
            }
          );
          var chatMessage = { userAccountId: this.loginUser.userId };
          this.stompClient.send("/app/active", {}, JSON.stringify(chatMessage));
        },
        (error) => {
          this.connected = false;
        }
      );
    },
    reloadPage: function () {
      if (this.customerOrPage == "C") {
        this.$store.commit("updateCustomerOrPage", "P");
        this.customerOrPage = "P";
      } else {
        this.$store.commit("updateCustomerOrPage", "C");
        this.customerOrPage = "C";
      }
      this.$store.commit("updatePage", {});
      this.changeRouter("/home", "Home");
      setTimeout(function () {
        location.reload();
      }, 500);
    },
    clickDrawer: function (item) {
      this.drawer = false;
      this.changeRouter(item.value, item.clickPath);
    },
    changePassword: function () {
      accountUserService
        .changePassword(this.password.old, this.password.new)
        .then((response) => {
          if (response > 0) {
            this.$swal("Successful", "Change Password", "success");
            this.logout();
          } else {
            this.$swal("unSuccessful", "Change Password", "error");
          }
          this.password = {
            old: "",
            new: "",
          };
        });
      this.passwordModel = false;
    },
    cancelChangePassword: function () {
      this.passwordModel = false;
      this.password = {};
    },
    hideToolbar: function (hide) {
      this.hiddenToolbar = hide;
      this.loginMounted();
    },
    changeRouter: function (path, clickPath) {
      this.drawer = false;

      if (path == "/logout") {
        this.logoutModel = true;
      } else if (path == "/change_password") {
        this.passwordModel = true;
      } else {
        if(clickPath=="Noti"){
          this.notiCount = 0;
        }
        this.clickPath = clickPath;
        document.cookie = "clickPath=" + clickPath;
        this.$router
          .push({
            path: path,
          })
          .catch(() => {});
      }
    },
    logout: function () {
      this.disconnect();
      this.$store.commit("updateUserAccount", {
        userName: "",
        password: "",
        role: "",
      });
      this.changeRouter("/login");
      this.logoutModel = false;
      this.hiddenToolbar = true;
      // this.logoutModel = false;
      // accountUserService
      //   .updateUserLogout()
      //   .then((response) => {
      //     this.hiddenToolbar = true;
      //     var temp = this;
      //     setTimeout(function () {
      //       temp.$store.commit("updateUserAccount", {
      //       userName: "",
      //       password: "",
      //       role: "",
      //     });
      //     temp.changeRouter("/login", "Home");
      // }, 500);
      //   })
      //   .catch((err) => {
      //     //this.$swal("Failed", err.response.data.message, "error");
      //   });
    },
    loginMounted() {
      if (this.isLogin) {
        this.loginUser = this.$store.state.userAccountChat;
        this.disconnect();
        this.connection();
        if (this.loginUser.profileName == null) {
          this.hiddenToolbar = true;
          this.$router.push("/userform").catch(() => {});
        } else {
          this.pageListMethod();
          this.hiddenToolbar = false;
        }
      } else {
        this.hiddenToolbar = true;
        this.$router.push("/login").catch(() => {});
      }
    },
    getNotiCount:function(){
      notiService
        .getNotiCount()
        .then((response) => {
          console.log(response);
          this.notiCount = response;
        })
        .catch((error) => {
          //this.$swal("Fail!", error.response.data.message, "error");
        });
    },
    uiAcceptMethod: function () {
      this.getNotiCount();
      this.page.splice(0);
      this.page.push({
        title: "Page",
        icon: "mdi-page-layout-body",
        value: "/page",
        clickPath: "Settings > Page",
      });
      this.settings.splice(0);
      if (this.$store.state.userAccountChat.role == "ADMIN") {
        this.settings.push({
          title: "User Account",
          icon: "mdi-account",
          value: "/ua",
          clickPath: "Settings > User Account",
        });
        this.settings.push({
          title: "UserType",
          icon: "mdi-page-layout-body",
          value: "/usertype",
          clickPath: "Settings > User Type",
        });
        this.settings.push({
          title: "Ui Accept",
          icon: "mdi-access-point",
          value: "/uiaccept",
          clickPath: "Settings > Ui Accept",
        });
      }
    },
  },
  watch: {
    uiAccept: function () {
      // this.page.splice(0);
      // if (this.uiAccept.page) {
      //   this.page.push({
      //     title: "Page",
      //     icon: "mdi-page-layout-body",
      //     value: "/page",
      //     clickPath: "Settings > Page",
      //   });
      // }
      // if (this.uiAccept.pageuser) {
      //   this.page.push({
      //     title: "Page User",
      //     icon: "mdi-clipboard-account",
      //     value: "/pageuser",
      //     clickPath: "Settings > Page User",
      //   });
      // }
      //this.settings.splice(0);
      // if (this.uiAccept.township) {
      //   this.settings.push({
      //     title: "Township",
      //     icon: "mdi-city",
      //     value: "/ts",
      //     clickPath: "Settings > Township",
      //   });
      // }
      // if (this.uiAccept.userAccount) {
      //   this.settings.push({
      //     title: "User Account",
      //     icon: "mdi-account",
      //     value: "/ua",
      //     clickPath: "Settings > User Account",
      //   });
      // }
      // if (this.uiAccept.company) {
      //   this.settings.push({
      //     title: "Company",
      //     icon: "mdi-domain",
      //     value: "/comp",
      //     clickPath: "Settings > Company",
      //   });
      // }
      // if (this.$store.state.userAccountChat.role == "ADMIN") {
      //   this.settings.push({
      //     title: "Ui Accept",
      //     icon: "mdi-access-point",
      //     value: "/uiaccept",
      //     clickPath: "Settings > Ui Accept",
      //   });
      // }
    },
  },
  components: {},
  name: "App",
};
</script>
<style scope>
html::-webkit-scrollbar {
  width: 0px;
}

html::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.699);
  border-radius: 3px;
}

html::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: #4caf50;
  padding: 3px;
  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.5);
}

div::-webkit-scrollbar {
  width: 10px;
  height: 0px;
}

div::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.699);

  border-radius: 3px;
}

div::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: #4caf50;
  -webkit-box-shadow: inset 0 0 0px rgba(0, 0, 0, 0.5);
}
</style>
